import React from "react";
import "./styles.scss";
// import Labels from '!!@svgr/webpack?{"svgoConfig":{"plugins": [{"mergePaths": false}, {"cleanupIDs": false}, {"removeRasterImages": true}]}}!../../images/maps/test.svg'

interface Props {
  rasterPath: string;
  vectorPath: string;
  originalSize: {
    width: number;
    height: number;
  };
  classes: string[];
}

interface State {
  width: number;
  height: number;
}

export class Map extends React.Component<Props, State> {
  private containerNode: React.RefObject<HTMLDivElement>;
  private raster: HTMLImageElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      width: this.props.originalSize.width,
      height: this.props.originalSize.height
    };
    this.containerNode = React.createRef<HTMLDivElement>();
    this.raster = new Image();
    this.resize = this.resize.bind(this);
  }

  resize() {
    console.log("Resize triggered");

    if (this.containerNode.current) {
      const containerNode = this.containerNode.current;
      const newWidth = containerNode.clientWidth;
      const newHeight =
        (newWidth * this.props.originalSize.height) /
        this.props.originalSize.width;
      const scaleX = this.props.originalSize.width / this.state.width;
      const scaleY = this.props.originalSize.height / this.state.height;

      // Update the SVG content according to its new size
      const svg = containerNode.getElementsByTagName("svg")[0];
      const elements = [...containerNode.getElementsByTagName("g")];

      elements.map(el => {
        console.log(el.className);
        const relativePositionX =
          el.getBoundingClientRect().left - svg.getBoundingClientRect().left;
        const relativePositionY =
          el.getBoundingClientRect().top - svg.getBoundingClientRect().top;

        const pctX = relativePositionX / this.state.width; // this.props.originalSize.width
        const pctY = relativePositionY / this.state.height; // this.props.originalSize.height

        const oldX = relativePositionX * scaleX;
        const oldY = relativePositionY * scaleY;

        const newX = pctX * newWidth;
        const newY = pctY * newHeight;

        const offsetX = newX - oldX;
        const offsetY = newY - oldY;

        // console.log('scaleX: ' + scaleX)
        // console.log('scaleY: ' + scaleY)
        // console.log('')
        // console.log('relativeX: ' + relativePositionX)
        // console.log('relativeY: ' + relativePositionY)
        // console.log('')
        // console.log('pctX: ' + pctX)
        // console.log('pctY: ' + pctY)
        // console.log('')
        // console.log('newX: ' + newX)
        // console.log('newY: ' + newY)
        // console.log('')
        // console.log('offsetX: ' + offsetX)
        // console.log('offsetY: ' + offsetY)
        // console.log('')
        // console.log('')

        el.style.transform = "translate(" + offsetX + "px, " + offsetY + "px)";
      });

      this.setState({
        width: newWidth,
        height: newHeight
      });
    }
  }

  componentDidMount() {
    // Resize the SVG once we know the size of the image it supports
    this.raster.src = this.props.rasterPath;
    this.raster.onload = () => {
      this.resize();
    };

    // We need to resize the SVG according to it's container (and probably the window)
    window.addEventListener("resize", this.resize);
  }

  componentDidUnMount() {
    window.removeEventListener("resize", this.resize);
  }

  render() {
    return (
      <div className="map-container">
        <div className="map-legend">
          <div className="map-classes">
            {this.props.classes.map((e, i) => {
              return (
                <div
                  key={"map-class-" + i}
                  className="map-class"
                  style={{ backgroundColor: e }}
                />
              );
            })}
          </div>
          <div className="map-label left">
            <i className="ui icon long arrow alternate left" /> Moins populaire
          </div>
          <div className="map-label right">
            Plus populaire <i className="ui icon long arrow alternate right" />
          </div>
        </div>
        <div ref={this.containerNode} className="map-layers">
          {/* <Labels
            width={this.state.width}
            height={this.state.height}
          /> */}
          <img src={this.props.rasterPath} />
        </div>
      </div>
    );
  }
}
